import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http'
import {Injectable, Injector} from '@angular/core'
import {SecurityService} from '@core/services/security.service'
import {Observable, throwError} from 'rxjs'
import {catchError} from 'rxjs/operators'

/**
 * Erkennt den Sitzungsablauf und löst die Abmeldung aus.
 *
 * `Injector` statt direkter Einspritzung ist Pflicht, nicht Geschmack: Der
 * `SecurityService` hängt über den `AuthService` am `HttpClient`. Würde er im
 * Konstruktor eingespritzt, entstünde ein zyklischer Abhängigkeitsgraph.
 * Erst zur Fehlerzeit auflösen umgeht das sauber.
 */
@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (TimeoutInterceptor.isAuthFailure(error)) {
          // Der Einmal-Guard im SecurityService sorgt dafür, dass zehn
          // gleichzeitig scheiternde Aufrufe genau EINEN Sprung ergeben.
          this.injector.get(SecurityService).forceLogout()
        }
        return throwError(error)
      })
    )
  }

  /**
   * Anmeldefehler = HTTP 401 oder 403 ODER der Rumpf enthält
   * "wrong credentials".
   *
   * Das Backend liefert ungültige Anmeldedaten überwiegend als 401 mit
   * `{"message": "Wrong credentials!"}`, in einzelnen Fällen aber als 403 oder
   * 500 mit derselben Meldung im Rumpf. Ein Auslöser allein reicht nicht.
   */
  private static isAuthFailure(error: unknown): boolean {
    if (!(error instanceof HttpErrorResponse)) {
      return false
    }
    if (error.status === 401 || error.status === 403) {
      return true
    }
    const body: any = error.error
    const message: string =
      typeof body === 'string' ? body : body?.message || body?.error || ''

    return (
      typeof message === 'string' &&
      message.toLowerCase().includes('wrong credentials')
    )
  }
}
